import styled from "styled-components";

export const MarwueeWrapper = styled.div`
  height: 100px;
  width: 100%;
  margin: 70px 0 50px;
  @media (max-width: 768.98px) {
    overflow: hidden;
    height: 260px;
    position: relative;
  }
  @media (max-width: 477.98px) {
    height: 200px;
  }
`;

export const MarqueYellow = styled.div`
  position: absolute;
  width: 100%;
  transform: rotate(-5deg);
  background: #fcff79;
  padding: 15px 0;
  z-index: 1;
  @media (max-width: 768.98px) {
    top: 50%;
    transform: rotate(-15deg) scale(1.1) translateY(-50%);
  }
`;

export const MarqueColor = styled.div`
  position: absolute;
  width: 100%;
  transform: rotate(3deg);
  border: 1px solid ${(props) => props.theme.borderColor};
  padding: 15px 0;
  @media (max-width: 768.98px) {
    top: 50%;
    transform: rotate(9deg) scale(1.1) translateY(-50%);
  }
`;
